import { Component, Inject, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { 
  OidcSecurityService,
  OpenIdConfiguration
} from 'angular-auth-oidc-client';  
import IDisplayUsers from './domain/ports/i-display-users';
import { ApplicationInsightsService } from './domain/applicationinsights-displayer';
import { TiamAdapterService } from './adapters/tiam-adapter.service';
import { LoadingService } from './service/loading.service';
declare function InitialR(appName:string, url: string, endpoint_config: string, endpoint_send: string, endpoint_send_support: string, token: string, isAngular: boolean, theme_default: string, access_token: string): any;

import {  TranslateService } from '@ngx-translate/core';
import { RoleUserTiamDto } from './domain/models/roleTiam';
import { UserRolesService } from './service/user-roles.service';

import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  configurations: OpenIdConfiguration[] | undefined;
  idToken:any; 
  accessToken:any;   
  private readonly applicationInsightsService =inject(ApplicationInsightsService); 
  private readonly TiamAdapterService = inject(TiamAdapterService);
  roles: RoleUserTiamDto[] = [];
  globalLoading = false;
  
  constructor(
    public oidcSecurityService1: OidcSecurityService,
    private translate: TranslateService,
    @Inject('IDisplayUsers') public userDisplayer: IDisplayUsers,
    private userRolesService: UserRolesService,
    private loadingService: LoadingService
  ){
    this.translate.setDefaultLang('en');
    this.translate.use('en'); // Cargar idioma
  }
  
  ngOnInit(): void {
    this.loadingService.getLoading().subscribe(isLoading => {
      this.globalLoading = isLoading;
    });
    this.configurations = this.oidcSecurityService.getConfigurations();
  
    this.oidcSecurityService
      .checkAuth()
      .subscribe(({ isAuthenticated, accessToken, idToken }) => {
        this.applicationInsightsService.trackTrace('app authenticated');
        this.accessToken = accessToken;
        this.idToken = idToken;
        
        if(isAuthenticated){
          this.TiamAdapterService.GetRolesUserTiam().subscribe(response  => {          
            const roles: RoleUserTiamDto[] = response.data; 
            this.roles = roles;
            this.userRolesService.setRoles(roles); 
          });
        } else {
          // Si no está autenticado, emitir array vacío para que los hijos funcionen igual
          this.userRolesService.setRoles([]);
        }
      });
  }

  login(): void {
          if (this.configurations && this.configurations.length > 0) {
            this.oidcSecurityService.authorize(this.configurations[0].configId);
          } else {
            console.error('Configurations are not available.');
          } 
  }

  refreshSession(): void {
    if (this.configurations && this.configurations.length > 0) {
    this.oidcSecurityService.authorize(this.configurations[0].configId);
  } else {
    console.error('Configurations are not available.');
  } 
  }

  logout(): void {
    if (this.configurations && this.configurations.length > 0) {
    this.oidcSecurityService
      .logoff(this.configurations[0].configId)
      .subscribe((result) => console.log(result));
    } else {
      console.error('Configurations are not available.');
    } 
  }
 
  initFeedbackTool() {
    InitialR(environment.feedbackTool.appName, environment.feedbackTool.url, '', '', '', this.idToken, true, "", this.accessToken ); 
  }
 
}
